import { D_SAG, Death } from '../entities/bosses/death';
/* ============================================================
   圖鑑：把 BOSS 的死亡編排接進展示台
   ============================================================

   死亡編排本身是**機械移植**的（`entities/bosses/death.ts`，由
   `tools/port-bosses.mjs` 從原型 §12 產生，`--check` 逐數字比對）。
   這一支只做「圖鑑要怎麼用它」，不重寫任何演出。

   四拍：停頓 → 抖動 → 吸氣 → 炸裂 → 落下。原型的用法有兩個要點：

   1. **炸裂之前 rig 還要繼續動**（`if (!Death.burst) upd(...)`）——
      抖動與吸氣是疊在正常動畫上的，不是取代它。
   2. **`step()` 回傳 timeScale**，停頓就是把它壓到 0.03。畫面沒有凍結
      （還在算），所有動作停在原地 —— 打擊感最便宜也最有效的一招。

   ⚠️ **炸裂會把 rig 拆掉**（`Object3D.attach()` 把每個骨段攤平成 root 底下
   的自由剛體），所以演完只能整隻重建。圖鑑是展示台，重建就重播。 */

/** 演完之後停多久再重播。原型的 `D_END` 是 5.60，圖鑑砍短一點 ——
    落下之後的靜止畫面看兩秒就夠了，展示台不需要等殘骸完全靜止。 */
var REPLAY_AT = 4.2;

var armed = false;

/** 開始演。`sc0` 是展品的縮放（炸裂前要把它還原，否則吸氣的縮放會被烘進碎塊）。 */
export function armCodexBossDeath(root, T, sc0) {
  if (armed) return;
  root.userData.sc0 = sc0;
  root.userData.px = root.position.x;
  root.userData.pz = root.position.z;
  Death.arm(root, T);
  armed = true;
}

/** 每個畫面幀。回傳 `{ pre, scale, done }`：
    `pre` = 還沒炸裂（rig 要繼續跑正常動畫）、`scale` = 這一幀的 timeScale、
    `done` = 演完了該重建。 */
export function stepCodexBossDeath(rdt, root) {
  if (!armed) return { pre: true, scale: 1, done: false };
  var scale = Death.step(rdt, root);
  return { pre: !Death.burst, scale: scale, done: Death.t >= REPLAY_AT };
}

/** 收乾淨。**離開圖鑑、換展品、關掉開關都要叫** —— FX 群組是掛在共用
    `scene` 上的，不收的話戰場上會浮著一圈爆炸環（而且沒有任何錯誤訊息）。 */
export function resetCodexBossDeath() {
  if (!armed) return;
  Death.reset();
  armed = false;
}

export function codexBossDeathArmed() { return armed; }
void D_SAG;
